// extracted by mini-css-extract-plugin
export default {"modal":"V0HGRe","personal-data__link":"eKpvAl","personal-data__text":"zxu1eo"};